import React from 'react'
import {Form, Submit} from './styled';
import Container from '../../components/Container';
import Input from '../../components/Form/Input';
import useForm from '../../hooks/useForm';
import Select from '../../components/Form/Select';
import { DsFlex, Hr } from '../Register/styled';
import { createStyles } from '@material-ui/styles';
import { makeStyles, Theme } from '@material-ui/core';
import Button from '../../components/Button';
import { UserContext } from '../../UserContext';
import getCep from 'cep-promise';
import { api } from '../../services/api';
import { default as MaterialUiAlert } from '@material-ui/lab/Alert';
import { Link } from 'react-router-dom';
import Alert from '../../components/Alert';
import { cnpjCpfMask } from '../../helpers';

const segments = [
    {id: 48, description: "LOJISTA"},
    {id: 49, description: "VENDEDOR PORTA A PORTA"},
    {id: 50, description: "ATACADISTA"},
    {id: 52, description: "SUPERMERCADO"},
    {id: 53, description: "HOTEL/ MOTEL / POUSADA / RESTAURANTE"},
    {id: 64, description: "E-COMMERCE"},
    {id: 62, description: "OUTROS"},
]

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            marginBottom: 10,
            width: '100%',
            '& > * + *': {
                marginTop: theme.spacing(2),
            },
        },
    }),
);

const EditUser: React.FC = () => {
    document.title = "Editar Usuário- Sultan Veste a Casa";

    const [success, setSuccess] = React.useState("");
    const [error, setError] = React.useState("");

    const cnpj_or_cpf = useForm('cnpj_cpf');
    const name = useForm('nome_completo');
    const email = useForm('email');
    const phone = useForm();
    const cellphone = useForm('telefone_celular');
    const cep = useForm('cep');
    const city = useForm('notEmpty');
    const address = useForm('notEmpty');
    const uf = useForm();
    const complement = useForm();
    const number = useForm('number');
    const neighborhood = useForm('notEmpty');
    const segment = useForm('notEmpty');

    const classes = useStyles();

    const {loading, setLoading} = React.useContext(UserContext);

    React.useEffect(() => {
        getUser();
        // eslint-disable-next-line
    }, []);

    const getUser = async () => {
        try{
            setLoading(true);

            const {data} = await api.get("/user");

            cnpj_or_cpf.setValue(data.user.sCPF);
            name.setValue(data.user.sNome);
            email.setValue(data.user.sEmail);
            cellphone.setValue(data.user.cellphone);
            phone.setValue(data.user.phone);
            cep.setValue(data.user.cep);
            uf.setValue(data.user.uf);
            segment.setValue(data.user.PKSegmento);
            address.setValue(data.user.address);
            city.setValue(data.user.city);
            neighborhood.setValue(data.user.neighborhood);
            complement.setValue(data.user.complement);
            number.setValue(data.user.number);
        }catch(error){
            const result = (error as Error).message;
            setError(result);
        }finally{
            setLoading(false);
        }
    }

    function onChangeCep(event: React.FormEvent<HTMLInputElement>) {
        const cepUser = event.currentTarget.value;
        if (cepUser.length === 9) {
            try {
                setLoading(true);

                getCep(event.currentTarget.value).then((response: any) => {
                    address.setValue(response.street);
                    neighborhood.setValue(response.neighborhood);
                    city.setValue(response.city);
                    uf.setValue(response.state);
                });
            } catch (error) {
                const result = (error as Error).message;
                setError(result);
            } finally {
                setLoading(false);
            }
        }

        cep.setValue(cepUser);
    }

    const updateUser = async (e: React.FormEvent) => {
        e.preventDefault();

        try {
            setLoading(true);

            const {data} = await api.put('/user', {
                name: name.value,
                email: email.value,
                cellphone: cellphone.value,
                phone: phone.value,
                cep: cep.value,
                uf: uf.value,
                city: city.value,
                neighborhood: neighborhood.value,
                number: number.value,
                address: address.value,
                complement: complement.value,
                segment: segment.value,
            });

            setSuccess(data.message);
        } catch (error) {
            const result = (error as Error).message;
            setError(result);
        } finally {
            setLoading(false);
        }
    }

    const handleMessageError = () => {
        setError('');
    }

    const handleMessageSuccess = () => {
        setSuccess('');
    }

    return (
        <Container>
            <Form className="shadow" onSubmit={updateUser}>
                <Input disabled label="Seu CPF/CNPJ: *" required
                        mask={cnpjCpfMask(cnpj_or_cpf.value)} autoComplete="off"
                        id="cpf_or_cnpj" type="text" {...cnpj_or_cpf}/>                                                                                              
                <Input label="Seu Nome Completo: *" required id="name"
                        type="text" {...name}/>
                <DsFlex className="align-items-end">
                    <Input label="Seu E-mail: *" required id="email" type="email" {...email}/>
                    <div className="direita">
                        <Link title="Alterar Senha" to={`${process.env.PUBLIC_URL}/usuario/alterar-senha`}>Alterar Senha</Link>
                    </div>
                </DsFlex>
                <Select label="Qual é o seu Segmento ?: *" required
                        id="segment" {...segment} options={segments}/>
                <Hr />
                <DsFlex>
                    <Input label="Celular para Contato: *" required
                            mask={['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/,]}
                            id="celular" type="text" {...cellphone}/>
                    <Input label="Telefone para Contato:"
                            mask={['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/,]}
                            autoComplete="off" id="telephone" type="text" {...phone}/>
                </DsFlex>                     
                <Hr />                                                                           
                <Input label="CEP: *" required
                    mask={[/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]} id="cep"
                    type="text" {...cep} onChange={onChangeCep}
                />
                <DsFlex id="localization">
                    <Input disabled required label="Endereço: *"
                            autoComplete="off" id="address" type="text" {...address}/>
                    <Input required label="N° *:" id="number" autoComplete="off"
                            showError={false} min="0" type="number" {...number}/>
                </DsFlex>
                {number.error &&
                    <div className={classes.root}>
                        <MaterialUiAlert severity="error">{number.error}</MaterialUiAlert>
                    </div>
                }                                                
                <DsFlex>
                    <Input disabled required label="Estado: *" id="city"
                            type="text" {...city}/>
                    <Input disabled required label="Bairro: *" id="neighborhood"
                            type="text" {...neighborhood}/>
                    <Input disabled required label="UF: *" id="uf" type="text" {...uf}/>
                </DsFlex>
                <Input label="Complemento:" id="complement" type="text" {...complement}/>   
                <Submit>
                    {loading ? <Button type="submit" disabled>Carregando...</Button> :
                    <Button type="submit">Finalizar</Button>}
                </Submit>                                                                                                                        
            </Form>
            <Alert open={error !== ''} onClose={handleMessageError} severity="error" message={error}/>                                                              
            <Alert open={success !== ''} onClose={handleMessageSuccess} severity="success" message={success}/>                                                              
        </Container>        
    )
}

export default EditUser;